const NOTIFICATION_EVENT = 'notification:show';

const buildNotificationDetail = ({
    type = 'info',
    message = '',
    persist = false,
    duration = 5000,
    dedupeKey = null,
} = {}) => ({
    type,
    message: String(message || '').trim(),
    persist: Boolean(persist),
    duration: Number(duration) > 0 ? Number(duration) : 5000,
    dedupeKey: dedupeKey ? String(dedupeKey) : null,
    createdAt: Date.now(),
});

export const showGlobalNotification = (detail = {}) => {
    const payload = buildNotificationDetail(detail);
    if (!payload.message) return;
    window.dispatchEvent(new CustomEvent(NOTIFICATION_EVENT, { detail: payload }));
};

const ensureContactAdminSuffix = (message = '') => {
    const text = String(message || '').trim();
    if (!text) return 'Twilio/STT service error. Contact Admin.';
    return /contact\s+admin\.?$/i.test(text) ? text : `${text} Contact Admin.`;
};

export const showTwilioAdminPopup = (message, options = {}) => {
    showGlobalNotification({
        type: 'error',
        persist: true,
        ...options,
        message: ensureContactAdminSuffix(message),
    });
};

export const notificationEventName = NOTIFICATION_EVENT;
